export default{
    dialogKpiao:{
        Headers:{
            title:"Add Invoice (Please verify details carefully to avoid reimbursement issues)",
            title1: "Invoice Management",
            title2: "Invoice Details",
            title3: "Invoice Information",
            title4: "Billing Information" ,
            title5: "Invoice Progress",
        },
        form:{
            invoType:"Invoice Type",
            invoType1:"Regular Invoice",
            invoType2:"VAT Special Invoice",
            invoCatgType:"Invoice Category",
            invoCatgType1:"Personal",
            invoCatgType2:"Corporate",
            invoContentType:"Invoice Content",
            invoContentType1:"Item Details",
            invoContentType2:"Product Category",
            invoTitle:"Invoice Title",
            taxIdentNum:"Unified Social Credit Code",
            invoRemarks:"Remarks",
            receName:"Recipient Name",
            tel:"Recipient Phone",
            areaList:"Region",
            addressDetail:"Detailed Address",
            registAddress:"Registered Address",
            registTel:"Registered Phone",
            bankName:"Bank Name",
            bankAccNum:"Bank Account",
            shopName: "Billing Entity",
            invoCatg: "Invoice Recipient",
            invoAmount: "Invoice Amount",
            applyDate: "Application Date",
            receName1: "Recipient Name",
            remarks: "Delivery Address" ,
            tel1: "Contact Number",
            xzdzfp: "Download E-Invoice",
            logisticsCompName: "Progress Tracking",
            logisticsCompName1: "Carrier",
            logisticsNum: "Tracking Number",
            fname: "E-Invoice",
            ddxx:"Order Information",
            wlxx: "Logistics Information"
        },
        placeholder:{
            invoTitle:"Enter invoice title",
            taxIdentNum:"Enter Unified Social Credit Code",
            invoRemarks:"Enter remarks",
            receName:"Enter recipient name",
            tel:"Enter recipient phone number",
            areaList:"Select region",
            addressDetail:"Enter detailed address",
            registAddress:"Enter registered address",
            registTel:"Enter registered phone",
            bankName:"Enter bank name",
            bankAccNum:"Enter bank account",
        },
        rules:{
            receName:"Enter recipient name!",
            receName1:"Enter 2-10 character recipient name!",
            areaList:"Select region",
            tel:"Enter phone number",
            tel1:"Enter valid phone number",
            addressDetail:"Enter detailed address!",
            addressDetail1:"Enter 4-50 character detailed address!",
            invoTitle:"Enter invoice title",
            invoTitle1:"Enter 2-50 character invoice title!",
            taxIdentNum:"Enter 15-20 character Unified Social Credit Code!",
            taxIdentNum1:"Enter valid Unified Social Credit Code!",
            registTel:"Enter registered phone!",
            registAddress:"Enter registered address!",
            registAddress1:"Enter 2-50 character registered address!",
            bankName:"Enter bank name!",
            bankName1:"Enter 4-10 character bank name!",
            bankAccNum:"Enter bank account!",
            bankAccNum1:"Enter valid bank account!",
        },
        Message:{
              success: "Download successful"
        },
        Alert:{
        },
        Button:{
            btnConfirm:"Save",
            btnClose:"Cancel",
            btnDetail: "View details"
        },
        Description:{
            defaultFlag:'Set as default invoice',
            defaultFlag1:"System will automatically select this invoice title when set"
        },
         Table:{
            headerName1:['Order Number','Merchant Name','Order Amount','Refund Amount','Invoiceable Amount','Payment Date','Action'],
        }
    }
}